// NOTE: these numbers match the enum in the EpsonSDK
enum EpsonBarcodeFormat {
  UPC_A = 0,
  UPC_E = 1,
  EAN13 = 2,
  JAN13 = 3,
  EAN8 = 4,
  JAN8 = 5,
  // CODE39 = 6,
  // ITF = 7,
  // CODABAR = 8,
  // CODE93 = 9,
  CODE128 = 10,
  // GS1_128 = 11,
  // GS1_DATABAR_OMNIDIRECTIONAL = 12,
  // GS1_DATABAR_TRUNCATED = 13,
  // GS1_DATABAR_LIMITED = 14,
  // GS1_DATABAR_EXPANDED = 15
}

export { EpsonBarcodeFormat };
